import React, { useState } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getTernaryValue } from 'common/utilities/utils';
import {
  displayAllCardsTemplateJSX,
  noSavedCardsTextJSX,
  DeleteCardConfirmModal,
} from './sharedTemplates/PaymentMethodsTemplates';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const MyPaymentMethodsView = props => {
  const { updateMenu, savedCards, allCardsTypesList, handleDeleteCard } = props;
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [deletingCardId, setDeletingCardId] = useState('');
  const handleClose = () => {
    setConfirmDialog(false);
  };
  const deleteCardPopup = cardId => {
    setConfirmDialog(true);
    setDeletingCardId(cardId);
  };

  const deleteCardHandler = () => {
    handleClose();
    handleDeleteCard(deletingCardId);
  };

  return (
    <div className='payment-methods col-12 au'>
      <div className='my-payment-methods-header-mobile'>
        <img
          className='backArrow-account-setting'
          data-testid='message-backArrow'
          onClick={() => updateMenu('')}
          src={IMAGE_PATH.SingleArrowback}
          alt='back button'
        />
        <span className='account-setting-text-header'>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.MY_PAYMENT_METHODS)}
        </span>
      </div>
      <div className='payment-methods-header col-12' data-testid='saved-cards-title'>
        <span className='payment-methods-heading'>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.SAVED_CARDS)} ({savedCards?.length})
        </span>
      </div>
      {getTernaryValue(
        savedCards?.length > 0,
        displayAllCardsTemplateJSX(savedCards, deleteCardPopup, allCardsTypesList),
        noSavedCardsTextJSX(),
      )}
      {confirmDialog && (
        <DeleteCardConfirmModal
          handleClose={handleClose}
          deleteCardHandler={deleteCardHandler}
          data-testid='delete-card-confirm-modal'
        />
      )}
    </div>
  );
};

export default React.memo(MyPaymentMethodsView);
